import { useEffect, useState } from "react";
import { deleteGroupMatch, deleteKnockoutMatch, deleteLeagueMatch } from "../../api/tournaments";
import { ConfirmDialog, Input } from "../../ui";
import "./styles.scss";

type DeleteMatchDialogProps = {
  matchId: string;
  matchFormat: string;
  formatId: string;
  isOpen: boolean;
  onClose: (update?: boolean) => void;
};

const DeleteMatchDialog = (props: DeleteMatchDialogProps) => {
  const [name, setName] = useState("");

  useEffect(() => {
    setName("");
  }, []);

  // The page renders this before the match has loaded.
  const shortId = (props.matchId ?? "").slice(0, 8);

  const handleDelete = async () => {
    if (name == shortId) {
      // A failed delete throws, which keeps the dialog open (as before).
      if (props.matchFormat === "League") await deleteLeagueMatch(props.formatId, props.matchId);
      if (props.matchFormat === "Group") await deleteGroupMatch(props.formatId, props.matchId);
      if (props.matchFormat === "Knockout") await deleteKnockoutMatch(props.formatId, props.matchId);
    }
  };

  return (
    <ConfirmDialog
      open={props.isOpen}
      onClose={(confirmed) => props.onClose(confirmed || undefined)}
      onConfirm={handleDelete}
      title="Are you sure?"
      message={
        <>
          <p>This action cannot be undone. If you delete this match, you will lose all details.</p>
          {/* Not uppercased: the id is typed exactly as shown */}
          <p>
            Type the match id <strong>{shortId}</strong> to delete it
          </p>
        </>
      }
      confirmLabel="Delete"
      confirmDisabled={name !== shortId}
    >
      <Input
        className="delete-match-dialog__input"
        aria-label="Match id"
        value={name}
        placeholder={shortId}
        onChange={(e) => setName(e.target.value)}
      />
    </ConfirmDialog>
  );
};

export default DeleteMatchDialog;
